// @vue/component
export default {
  name: 'ShIconWithDescription',

  props: {
    color: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
    fontSize: {
      type: String,
      default: '',
    },
  },

  computed: {
    iconStyle() {
      return {
        backgroundColor: this.color,
        width: this.width,
        height: this.height,
        fontSize: this.fontSize,
      };
    },
  },
};
